import classes from './TaskListItem.module.css'
import * as React from 'react';
import classNames from 'classnames';
import { Task } from '../../types';
import { getTaskCategoryColor, zeroPadId } from '../../utils/taskUtils';
import { useTooltip } from './Tooltip';
import { useIsTaskSelected } from '../../state/context';

type TaskListItem = {
  task: Task;
  isExpanded: boolean;
  organizationName?: string;
  className?: string;
  onMouseEnter?: (task: Task, ref: React.MutableRefObject<HTMLDivElement>) => void;
  onMouseLeave?: (task: Task, ref: React.MutableRefObject<HTMLDivElement>) => void;
};

const TaskListItem = ({
  task,
  isExpanded,
  organizationName,
  className,
  onMouseEnter,
  onMouseLeave,
}: TaskListItem) => {
  const taskRef = React.useRef<HTMLDivElement>(null);
  const setTooltip = useTooltip();
  const isSelected = useIsTaskSelected(task);

  return (
    <div
      key={task.id}
      ref={taskRef}
      onMouseEnter={() => isExpanded && task.title && setTooltip(task, taskRef)}
      onMouseLeave={() => setTooltip(null)}
      className={classNames(
        'px-3 text-xs relative',
        className,
        isSelected && 'bg-yellow-200',
      )}
    >
      {task.taskUrl && (
        <a
          href={task.taskUrl}
          target="_blank"
          rel="noreferrer"
          className="absolute inset-0"
        />
      )}
      <div className={`border-b border-gray-300 flex items-center ${isExpanded ? 'justify-start' : 'justify-center'} text-xxs ${classes['task']}`}>
        <span className="font-semibold">{zeroPadId(task.id)}</span>
        <div
          className={`flex-none w-1.5 h-1.5 ml-1 ${getTaskCategoryColor(task.category)}`}
        />
        {isExpanded && (
          <div className="ml-2.5 whitespace-nowrap overflow-hidden overflow-ellipsis">{task.title}</div>
        )}
        {isExpanded && organizationName && (
          <div className="flex-none pl-2 w-16 text-right ml-auto whitespace-nowrap overflow-hidden overflow-ellipsis">
            {organizationName}
          </div>
        )}
        {task.statusCode === 'onHold' && (
          <div className="ml-auto">
            <div className="hold-badge" />
          </div>
        )}
      </div>
    </div>
  );
};

export default TaskListItem;
